import BackOffice from "../../components/BackOffice";

function Home() {
    return<BackOffice>
        
    </BackOffice>
}

export default Home;